/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 11:14:50
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-26 17:09:05
 */

export default {
  path: 'bill',
  component: () => import('@/pages/bill/List'),
  meta: {
    title: '业务清单审核'
  },
  children: [
    // {
    //   path: 'create',
    //   component: () => import(/* webpackChunkName: "bill-create" */ '@/pages/bill/CreateEdit'),
    //   meta: {title:'上传结算清单'},
    // },
    // {
    //   path: ':bill_id/edit',
    //   component: () => import(/* webpackChunkName: "bill-edit" */ '@/pages/bill/CreateEdit'),
    //   meta: {title:'上传结算清单'},
    // },
    // {
    //   path: ':bill_id/view',
    //   component: () => import(/* webpackChunkName: "bill-view" */ '@/pages/bill/CreateEdit'),
    //   meta: {title:'查看结算清单'},
    // },
]
}
